import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app-state';
import { workspaceReducerFn } from './workspace';
import { currentUserReducerFn } from './current-user';

export const appReducers: ActionReducerMap<AppState> = {
  workspace: workspaceReducerFn,
  currentUser: currentUserReducerFn,
};
